import { render } from "./InputPriorityDev.vue?vue&type=template&id=ed0e6036"
import script from "./InputPriorityDev.vue?vue&type=script&lang=js"
export * from "./InputPriorityDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__